<template>
	<div class="create-page">
		<div class="create-content">
			<el-form ref="form" :model="form" label-position="top">
				<!-- 索赔申请 -->
				<div class="create-section">
					<h3>
						索赔申请
						<div class="notice" v-if="form.repairType == 1" @click="dialogVisible = true">产品保修期限及例外条款</div>
					</h3>
					<div class="type-list">
						<el-tooltip
							class="item"
							effect="dark"
							content="请点击“保修期限及例外条款”确认申请零件是否属于保修范围并上移确认申请机型是否在保修期内"
							placement="bottom"
							popper-class="create-tooltip"
							v-if="form.id == undefined || (form.id && form.repairType == 1)">
							<div class="claim-type" @click="form.repairType = 1" :class="form.repairType == 1 ? 'selected' : ''">
								保修期内机器零件故障
								<div class="tip">请点击“保修期限及例外条款”确认申请零件是否属于保修范围并上移确认申请机型是否在保修期内</div>
							</div>
						</el-tooltip>
						<el-tooltip
							class="item"
							effect="dark"
							content="仅限直接从理光订购零件的代理商申请"
							placement="bottom"
							popper-class="create-tooltip"
							v-if="form.id == undefined || (form.id && form.repairType == 2)">
							<div class="claim-type" @click="form.repairType = 2" :class="form.repairType == 2 ? 'selected' : ''">
								理光单独订购零件
								<div class="tip">仅限直接从理光订购零件的代理商申请</div>
							</div>
						</el-tooltip>
						<el-tooltip
							class="item"
							effect="dark"
							content="仅限直接从理光订购的代理商申请（参考：不同型号色粉储存及运输条件-最高温度分别低于40℃或50℃/湿度低于80%RH，35℃以下最大储存期1~2年）"
							placement="bottom"
							popper-class="create-tooltip"
							v-if="form.id == undefined || (form.id && form.repairType == 3)">
							<div class="claim-type" @click="form.repairType = 3" :class="form.repairType == 3 ? 'selected' : ''">
								商品(耗材)故障
								<div class="tip">
									仅限直接从理光订购的代理商申请（参考：不同型号色粉储存及运输条件-最高温度分别低于40℃或50℃/湿度低于80%RH，35℃以下最大储存期1~2年）
								</div>
							</div>
						</el-tooltip>
					</div>
				</div>
				<!-- 申请方信息 -->
				<div class="create-section pb0">
					<h3>申请方信息：{{ form.applyOrgName }}</h3>
				</div>
				<!-- 资料后补 -->
				<div class="create-section" :class="supplementFlag ? '' : 'pb0'">
					<h3>
						索赔状态
						<el-tag type="info">{{ auditStatusMsg }}</el-tag>
						<span class="number-span" v-if="form.serialNumber">编号：{{ form.serialNumber }}</span>
					</h3>
					<div class="add-section" v-if="supplementFlag">
						<p class="title1">此单为资料候补</p>
						<p class="title2">请务必于索赔零件发货后10个工作日补齐此单所欠资料，否则将无法进行下次索赔并可能涉及赔偿</p>
						<el-input
							v-model="lastIntro"
							placeholder="资料候补补充说明（如涉及先行赔付，请点击本页下方“打印索赔报告书”按钮打印后随故障件一起邮寄）"></el-input>
						<el-button v-if="isPrepaid" type="primary" @click="handleAddressInfo">补写寄件信息</el-button>
						<el-button type="primary" @click="handleSupplement">提交资料候补审批</el-button>
					</div>
				</div>
				<!-- 日志 -->
				<div class="create-section log-section" v-if="logList.length > 0">
					<h3>日志</h3>
					<el-table :data="logList" :header-cell-style="{ color: '#444' }">
						<el-table-column prop="createTime" label="时间" width="160"></el-table-column>
						<el-table-column prop="createUsrCompany" label="执行方"></el-table-column>
						<el-table-column prop="createName" label="执行人" width="120"></el-table-column>
						<el-table-column prop="operNotes" label="事件"></el-table-column>
						<el-table-column prop="remark" label="批注"></el-table-column>
					</el-table>
				</div>
				<!-- 资料审核方 -->
				<div class="create-section">
					<h3 v-if="form.auditOrgType == '1'" class="border-bottom-none height45">一级审批代理商</h3>
					<p v-if="form.auditOrgType == '1'" class="subtitle">{{ form.auditOrgName }}</p>
					<h3 class="border-bottom-none height45">理光审批</h3>
					<p class="subtitle">总部</p>
				</div>
				<!-- 基本信息 -->
				<div class="create-section">
					<h3>基本信息</h3>
					<div class="grid-box">
						<div>
							<el-form-item label="机型及开发名" prop="repairDevices">
								<el-cascader
									v-model="form.repairDevices"
									:options="repairDeviceOptions"
									:props="{ value: 'id', label: 'name' }"
									:disabled="form.id ? true : false"></el-cascader>
							</el-form-item>
						</div>
						<div>
							<el-form-item label="机号" prop="repairDeviceNumber">
								{{ form.repairDeviceNumber }}
							</el-form-item>
						</div>
					</div>
					<div class="grid-box">
						<div>
							<el-form-item label="安装日期" prop="partsClaimWarranty.installDate">
								{{ form.partsClaimWarranty.installDate }}
							</el-form-item>
						</div>
						<div>
							<el-form-item
								label="发票日期(请注意有效发票必须包含机型/销售日期/客户名称与申请索赔资料一致)"
								prop="partsClaimWarranty.invoiceDate"
								class="el-form-item1">
								{{ form.partsClaimWarranty.invoiceDate }}
							</el-form-item>
						</div>
						<div>
							<el-form-item label="故障日期" prop="partsClaimWarranty.faultDate">
								{{ form.partsClaimWarranty.faultDate }}
							</el-form-item>
						</div>
						<div>
							<el-form-item label="计数器（黑白）" prop="partsClaimWarranty.blackWhiteCounter">
								{{ form.partsClaimWarranty.blackWhiteCounter }}
							</el-form-item>
						</div>
						<div>
							<el-form-item label="计数器（彩色）" prop="partsClaimWarranty.colorCounter">
								{{ form.partsClaimWarranty.colorCounter }}
							</el-form-item>
						</div>
						<div>
							<el-form-item label="制版计数器" prop="partsClaimWarranty.plateCounter">
								{{ form.partsClaimWarranty.plateCounter }}
							</el-form-item>
						</div>
					</div>
					<div class="mr20">
						<el-form-item label="故障现象" prop="partsClaimWarranty.failureSymptom">
							{{ form.partsClaimWarranty.failureSymptom }}
						</el-form-item>
					</div>
					<div class="mr20">
						<el-form-item label="故障原因" prop="partsClaimWarranty.failureReason">
							{{ form.partsClaimWarranty.failureReason }}
						</el-form-item>
					</div>
					<div class="mr20">
						<el-form-item label="故障处理措施" prop="partsClaimWarranty.failureAction">
							{{ form.partsClaimWarranty.failureAction }}
						</el-form-item>
					</div>
					<div class="mr20">
						<el-form-item label="故障处理结果" prop="partsClaimWarranty.failureResult">
							{{ form.partsClaimWarranty.failureResult }}
						</el-form-item>
					</div>
					<div class="mr20">
						<el-form-item label="索赔件收货地址" prop="partsClaimWarranty.claimAddress">
							{{ form.partsClaimWarranty.claimAddress }}
						</el-form-item>
					</div>
					<div class="mr20">
						<el-form-item label="补充说明栏" prop="partsClaimWarranty.additionalNotes">
							{{ form.partsClaimWarranty.additionalNotes }}
						</el-form-item>
					</div>
				</div>
				<!-- 勾选项 -->
				<div class="create-section">
					<h3>勾选项</h3>
					<div class="radio-box">
						<p>保修卡是否已登录“理光保修卡管理系统”，且当前填写信息与“保修卡管理系统”一致</p>
						<el-tag type="success" v-if="form.partsClaimWarranty.warrantyCardInSystem == '1'">是</el-tag>
						<el-tag type="danger" v-else>否</el-tag>
					</div>
					<!-- 保修卡 -->
					<div class="upload-box" v-if="form.partsClaimWarranty.warrantyCardInSystem == '0' && form.partsClaimWarranty.warrantyCardInSystem != ''">
						<h4>附件</h4>
						<p>请将申请机号的保修卡登录理光保修卡管理系统或者上传保修卡第一或第三联</p>
						<FileList :file-list="cardInSystemFileIdList" list-name="cardInSystemFileIdList" class="mt4"></FileList>
					</div>
				</div>
				<!-- 上传附件 -->
				<div class="create-section">
					<h3>上传附件</h3>
					<!-- 购机发票或租赁合同 -->
					<div class="upload-box">
						<h4>购机发票或租赁合同</h4>
						<p>发票客户名称与填写的客户名一致并有机型注明、或者备注</p>
						<div v-if="supplementFlag">
							<el-upload
								:action="action"
								:headers="headers"
								:multiple="true"
								:show-file-list="false"
								:before-upload="handleBeforeUpload"
								:on-error="handleError"
								:on-success="(res, file, list) => handleSuccess('purchase', res, file, list)">
								<el-button icon="el-icon-paperclip">上传文件</el-button>
							</el-upload>
							<FileList
								:file-list="purchaseLeaseFileIdList"
								list-name="purchaseLeaseFileIdList"
								closable
								@onRemove="handleAttachFileRemove"
								class="mt4"></FileList>
						</div>
						<FileList v-else :file-list="purchaseLeaseFileIdList" list-name="purchaseLeaseFileIdList" class="mt4"></FileList>
						<el-form-item label="备注" prop="partsClaimWarranty.purchaseLeaseRemark">
							{{ form.partsClaimWarranty.purchaseLeaseRemark }}
						</el-form-item>
					</div>
					<!-- SMC（系统参数报告） -->
					<div class="upload-box">
						<h4>SMC（系统参数报告）</h4>
						<p>请打印全套SMC（如多功能复印机SP5990-1）后扫描上传</p>
						<div v-if="supplementFlag">
							<el-upload
								:action="action"
								:headers="headers"
								:multiple="true"
								:show-file-list="false"
								:before-upload="handleBeforeUpload"
								:on-error="handleError"
								:on-success="(res, file, list) => handleSuccess('smc', res, file, list)">
								<el-button icon="el-icon-paperclip">上传文件</el-button>
							</el-upload>
							<FileList :file-list="smcFileIdList" list-name="smcFileIdList" closable @onRemove="handleAttachFileRemove" class="mt4"></FileList>
						</div>
						<FileList v-else :file-list="smcFileIdList" list-name="smcFileIdList" class="mt4"></FileList>
						<el-form-item label="备注" prop="partsClaimWarranty.smcRemark">
							{{ form.partsClaimWarranty.smcRemark }}
						</el-form-item>
					</div>
					<!-- 故障样张或照片，或者备注 -->
					<div class="upload-box">
						<h4>故障样张或照片，或者备注</h4>
						<div v-if="supplementFlag">
							<el-upload
								:action="action"
								:headers="headers"
								:multiple="true"
								:show-file-list="false"
								:before-upload="handleBeforeUpload"
								:on-error="handleError"
								:on-success="(res, file, list) => handleSuccess('failureSample', res, file, list)">
								<el-button icon="el-icon-paperclip">上传文件</el-button>
							</el-upload>
							<FileList
								:file-list="failureSampleFileIdList"
								list-name="failureSampleFileIdList"
								closable
								@onRemove="handleAttachFileRemove"
								class="mt4"></FileList>
						</div>
						<FileList v-else :file-list="failureSampleFileIdList" list-name="failureSampleFileIdList" class="mt4"></FileList>
						<el-form-item label="备注" prop="partsClaimWarranty.failureSampleRemark">
							{{ form.partsClaimWarranty.failureSampleRemark }}
						</el-form-item>
					</div>
					<!-- 故障零件或耗材（色粉）照片 -->
					<div class="upload-box">
						<h4>故障零件或耗材（色粉）照片</h4>
						<div v-if="supplementFlag">
							<el-upload
								:action="action"
								:headers="headers"
								:multiple="true"
								:show-file-list="false"
								:before-upload="handleBeforeUpload"
								:on-error="handleError"
								:on-success="(res, file, list) => handleSuccess('faultyParts', res, file, list)">
								<el-button icon="el-icon-paperclip">上传文件</el-button>
							</el-upload>
							<FileList
								:file-list="faultyPartsFileIdList"
								list-name="faultyPartsFileIdList"
								closable
								@onRemove="handleAttachFileRemove"
								class="mt4"></FileList>
						</div>
						<FileList v-else :file-list="faultyPartsFileIdList" list-name="faultyPartsFileIdList" class="mt4"></FileList>
					</div>
				</div>
				<!-- 客户信息 -->
				<div class="create-section">
					<h3>客户信息</h3>
					<div class="grid-box">
						<div>
							<el-form-item label="用户名" prop="partsClaimCustomer.userName">
								{{ form.partsClaimCustomer.userName }}
							</el-form-item>
						</div>
						<div>
							<el-form-item label="联系人姓名" prop="partsClaimCustomer.contactName">
								{{ form.partsClaimCustomer.contactName }}
							</el-form-item>
						</div>
						<div>
							<el-form-item label="用户电话" prop="partsClaimCustomer.userPhone">
								{{ form.partsClaimCustomer.userPhone }}
							</el-form-item>
						</div>
					</div>
					<div class="grid-box grid-box1">
						<div>
							<el-form-item label="省市区" prop="partsClaimCustomer.allAddress">
								<el-cascader
									v-model="form.partsClaimCustomer.allAddress"
									:options="addressOptions"
									:props="{ value: 'code', label: 'name' }"
									:disabled="form.id ? true : false"></el-cascader>
							</el-form-item>
						</div>
						<div>
							<el-form-item label="详细地址" prop="partsClaimCustomer.addressDetail">
								{{ form.partsClaimCustomer.addressDetail }}
							</el-form-item>
						</div>
					</div>
				</div>
				<!-- 机器零件信息 -->
				<div class="create-section">
					<h3>{{ partTitleObj[form.repairType] }}信息</h3>
					<!-- 动态生成的零件信息部分 -->
					<div class="flex part-info-box" v-for="(part, index) in form.partsDetailList" :key="index">
						<div class="flex-1">
							<div class="part-info-item">
								<div class="info-box">
									<p class="title">{{ partTitleObj[form.repairType] }}名称</p>
									<p class="content">{{ part.partsName }}</p>
								</div>
								<i class="el-icon-tickets" @click="$copyText(part.partsName)"></i>
							</div>
							<div class="part-info-item">
								<div class="info-box">
									<p class="title">{{ partTitleObj[form.repairType] }}编号</p>
									<p class="content">{{ part.partsNumber }}</p>
								</div>
								<i class="el-icon-tickets" @click="$copyText(part.partsNumber)"></i>
							</div>
							<div class="part-info-item" v-if="part.partsNumberNew != null">
								<div class="info-box">
									<p class="title">{{ partTitleObj[form.repairType] }}新编号</p>
									<p class="content">{{ part.partsNumberNew }}</p>
								</div>
								<i class="el-icon-tickets" @click="$copyText(part.partsNumberNew)"></i>
							</div>
							<div class="part-info-item">
								<div class="info-box">
									<p class="title">申请数量</p>
									<p class="content">{{ part.partsAmount }}</p>
								</div>
								<i class="el-icon-tickets" @click="$copyText(part.partsAmount)"></i>
							</div>
							<div class="part-info-item" v-if="part.partsBatchNumber != null">
								<div class="info-box">
									<p class="title">批号</p>
									<p class="content">{{ part.partsBatchNumber }}</p>
								</div>
								<i class="el-icon-tickets" @click="$copyText(part.partsBatchNumber)"></i>
							</div>
							<img class="watermark" v-if="part.lastResult == 1" src="@/assets/images/claim-fail.png" alt="" />
							<img
								class="watermark"
								v-if="part.currentAudit && part.currentAudit.auditStatus == 3"
								src="@/assets/images/claim-success.png"
								alt="" />
						</div>
						<div class="flex-1 part-info-box-right">
							<div v-if="[3, 10].includes(auditStatus)">零件索赔进度： 实物审批中</div>
							<div v-if="[4, 7, -7, 9, 11, 12].includes(auditStatus)">
								<div class="right-item">实物检测结果： {{ part.partsResult == 1 ? "拒绝" : "同意" }}</div>
								<div class="right-item">零件索赔进度：{{ progressMsg(part) }}</div>
								<el-button v-if="part.partsResult == 1" type="info" @click="checkAddressInfo(part.partsClaimExpress)">
									查看索赔退件信息
								</el-button>
								<div class="right-item" v-if="part.currentAudit && part.currentAudit.auditStatus == 2">
									预计发货时间： {{ part.estimatedShippingTime }}
								</div>
								<div v-if="part.currentAudit && part.currentAudit.auditStatus == 3" class="right-item">
									发货订单号：{{ part.partsClaimExpress.expressNumber }}
								</div>
								<div v-if="part.currentAudit && part.currentAudit.auditStatus == 3" class="right-item">
									发货操作时间(系统)：{{ part.currentAudit.operTime }}
								</div>
								<div v-if="part.currentAudit && part.currentAudit.auditStatus == 3" class="right-item">
									发货时间(录入)：{{ part.actualShippingTime }}
								</div>
								<div class="right-item word-bread-all" v-if="part.currentAudit && [2, 3, -2].includes(part.currentAudit.auditStatus)">
									发货批注： {{ part.currentAudit.remark }}
								</div>
								<div class="right-item flex" v-if="part.fileList.length > 0">
									<span>附件说明</span>
									<div class="flex-1">
										<FileList :file-list="part.fileList" class="mt4"></FileList>
									</div>
								</div>
								<el-button v-if="part.partsResult == 2 && part.partsClaimExpress" type="info" @click="checkAddressInfo(part.partsClaimExpress)">
									查看索赔邮寄信息
								</el-button>
							</div>
						</div>
					</div>
				</div>
			</el-form>
		</div>
		<div class="create-footer">
			<el-button type="info" @click="handleBack">返回</el-button>
			<el-button type="primary" @click="handleDownloadPdf" v-if="[7, 9, 11, 12].includes(auditStatus)">打印索赔报告书</el-button>
		</div>
		<el-dialog title="" :visible.sync="dialogVisible" width="70%" class="iframe-dialog">
			<iframe title="产品保修期限及例外条款" src="https://ricohhome.i-unc.com/support/policy#exception" frameborder="0"></iframe>
			<span slot="footer" class="dialog-footer">
				<el-button type="primary" @click="dialogVisible = false">已阅读</el-button>
			</span>
		</el-dialog>
		<AddressInfo ref="addressInfo" @refresh="updateExpress"></AddressInfo>
		<ShowAddressInfo ref="showAddressInfo"></ShowAddressInfo>
		<!-- 现场技术报告书 -->
		<appendix1 ref="appendix1" />
	</div>
</template>

<script>
const defaultSettings = require("@/settings.js");
const hostName = defaultSettings.hostName;
import { claimWarrantyInfo } from "@/api/claim";
import FileList from "../components/FileList.vue";
import AddressInfo from "../components/addExpress.vue";
import ShowAddressInfo from "../components/showAddressInfo.vue";
import appendix1 from "@/components/PdfTemplate/AppendixReport/appendix1.vue";
export default {
	components: {
		FileList,
		AddressInfo,
		ShowAddressInfo,
		appendix1,
	},
	data() {
		return {
			// 产品保修期限及例外条款
			dialogVisible: false,
			// 申请方信息
			applyOptions: [],
			// 申请方人员信息
			applyUserList: [],
			// 申请公司搜索
			loadingApplyUser: false,
			// 申请方信息
			auditOptions: [],
			// 申请方人员信息
			auditUserList: [],
			// 申请公司搜索
			loadingAuditUser: false,
			// 机型及开发名
			repairDeviceOptions: [],
			// 省市县三级
			addressOptions: [],
			form: {
				repairType: "", // 索赔的类型 1、保修期内机器零件故障 2、理光单独订购零件 3、商品（耗材故障）
				applyOrgType: "", // 申请方信息-机构类型 1、网络店 2、特约维修店 3、代理商 4、分部
				applyOrgId: "", // 申请方信息 对应的机构id
				auditOrgType: "", // 资料审核方-机构类型 1、其它进货代理商 2、理光
				auditOrgId: "", // 资料审核方 对应的机构id
				repairModelId: "", // 机型及开发名 一级
				repairDeviceId: "", // 机型及开发名 二级
				repairDeviceNumber: "", // 机号
				isSubmit: 0, // 是否提交 0否(表示暂存)  1是(提交索赔)
				repairDevices: [],
				//基本信息
				partsClaimWarranty: {
					installDate: "", // 安装日期
					invoiceDate: "", // 发票日期
					faultDate: "", // 故障日期
					blackWhiteCounter: "", // 计数器（黑白）
					colorCounter: "", // 计数器（彩色）
					plateCounter: "", // 制版计数器
					failureSymptom: "", // 故障现象
					failureReason: "", // 故障原因
					failureAction: "", // 故障处理措施
					failureResult: "", // 故障处理结果
					claimAddress: "", // 索赔件收货地址
					additionalNotes: "", // 补充说明栏
					warrantyCardInSystem: "", // 保修卡是否在系统内 0否 1是
					cardInSystemFileIdList: [], // 保修卡附件列表
					purchaseLeaseFileIdList: [], //购机发票或租赁合同上传文件的id
					purchaseLeaseRemark: "", // 购机发票或租赁合同-备注
					smcFileIdList: [], //SMC（系统参数报告）上传文件的id
					smcRemark: "", // SMC（系统参数报告）-备注
					failureSampleFileIdList: [], //故障样张或照片上传文件的id
					failureSampleRemark: "", // 故障样张或照片-备注
					faultyPartsFileIdList: [], // 故障零件或耗材（色粉）上传文件的id
				},
				// 客户信息
				partsClaimCustomer: {
					// 省市县三级，提交时删除
					allAddress: [],
					userName: "", // 用户名
					contactName: "", // 联系人姓名
					userPhone: "", // 用户电话
					province: "", // 省
					city: "", // 市
					district: "", // 区县
					addressDetail: "", // 详细地址
				},
				// 机器零件信息
				partsDetailList: [],
			},
			// 保修卡附件列表
			cardInSystemFileIdList: [],
			// 购机发票或租赁合同附件列表
			purchaseLeaseFileIdList: [],
			// SMC（系统参数报告）附件列表
			smcFileIdList: [],
			// 故障样张或照片附件列表
			failureSampleFileIdList: [],
			// 故障零件或耗材（色粉）附件列表
			faultyPartsFileIdList: [],
			// 机器零件列表
			partsDetailList: [],
			// 索赔管理员是否显示
			applyOrgFlag: false,
			// 资料审核管理员是否显示
			auditOrgFlag: false,
			// 订购信息
			partTitleObj: {
				1: "机器零件",
				2: "订购零件",
				3: "商品(耗材)",
			},
			// 资料后补状态
			supplementFlag: false,
			// 资料后补说明或者先行赔付说明
			lastIntro: "",
			// 先行赔付
			isPrepaid: false,
			// 先行赔付寄件信息
			prepaidExpress: null,
			// 索赔状态
			auditStatus: "",
			auditStatusMsg: "",
			logList: [],
		};
	},
	computed: {
		action() {
			return hostName + "bsi/sysAttachFile/addFileOss";
		},
		headers() {
			const token = sessionStorage.getItem("token") || "";
			return {
				token: token,
			};
		},
		// 是否是超级管理员
		isSuperAdmin() {
			const userInfoStr = window.sessionStorage.getItem("userInfo");
			if (!userInfoStr) return false;
			const userInfo = JSON.parse(userInfoStr);
			if (!userInfo) return false;
			if (userInfo.superAdminFlag === "1") return true;
			return false;
		},
	},
	mounted() {
		// 获取机型及开发名
		this.getRepairDevice();
		// 获取省市县三级
		this.getDataAddr();
		// 获取单个索赔信息
		const claimId = sessionStorage.getItem("claimId") || this.$route.query.claimId;
		if (claimId) {
			this.getClaimWarrantyInfo(claimId);
			this.getAuditLogList(claimId);
		} else {
			this.form.id ? delete this.form.id : "";
		}
	},
	methods: {
		// 获取审核日志
		getAuditLogList(claimId) {
			let self = this;
			self.$request.post("getAuditLogList", false, { id: claimId }, function (r) {
				if (r.code == "0") {
					let logList = [];
					for (const element of r.data) {
						if (element.remark) {
							logList.push(element);
						}
					}
					self.logList = logList;
					console.log("审核日志", self.logList);
				} else {
					self.$message.error(r.msg);
				}
			});
		},
		// 获取单个索赔信息
		getClaimWarrantyInfo(claimId) {
			let self = this;
			claimWarrantyInfo(claimId, true)
				.then((r) => {
					if (r.code == "0") {
						self.$nextTick(() => {
							sessionStorage.setItem("claimInfo", JSON.stringify(r.data));
							sessionStorage.setItem("claimId", r.data.id);
							sessionStorage.setItem("repairType", r.data.repairType);

							// 申请被拒，跳转编辑页面重新提交
							if ([-2, -3].includes(r.data.currentAudit?.auditStatus) || (r.data.isSubmit == 0 && r.data.currentAudit == null)) {
								sessionStorage.setItem("claimId", r.data.id);
								self.$router.push({
									name: "claimCreate",
									query: {
										claimId: r.data.id,
									},
								});
								return;
							}

							self.form = Object.assign({}, self.form, r.data);
							self.form.partsDetailList = [...r.data.partsDetailList];
							self.auditStatus = r.data?.currentAudit?.auditStatus;
							// 机型及开发名
							r.data.repairModelId ? (self.form.repairDevices = [r.data.repairModelId, r.data.repairDeviceId]) : [];
							// 省市区
							r.data.partsClaimCustomer.province
								? (self.form.partsClaimCustomer.allAddress = [
										r.data.partsClaimCustomer.province,
										r.data.partsClaimCustomer.city,
										r.data.partsClaimCustomer.district,
									])
								: [];
							self.cardInSystemFileIdList = r.data.partsClaimWarranty.cardInSystemFileList;
							self.purchaseLeaseFileIdList = r.data.partsClaimWarranty.purchaseLeaseFileList;
							self.smcFileIdList = r.data.partsClaimWarranty.smcFileList;
							self.failureSampleFileIdList = r.data.partsClaimWarranty.failureSampleFileList;
							self.faultyPartsFileIdList = r.data.partsClaimWarranty.faultyPartsFileList;
							self.form.partsClaimWarranty.warrantyCardInSystem = String(r.data.partsClaimWarranty.warrantyCardInSystem);

							if (r.data.partsClaimWarranty.isAdditional == 1 && [11, 12, -8].includes(r.data.currentAudit.auditStatus)) {
								self.supplementFlag = true;
								r.data.partsClaimWarranty.isPrepaid == 1 ? (self.isPrepaid = true) : (self.isPrepaid = false);
								r.data.partsClaimWarranty.prepaidExpress == null ? (self.prepaidExpress = false) : (self.prepaidExpress = true);
							} else {
								self.supplementFlag = false;
							}
							self.auditStatusMsg = r.data.currentAudit.operNotes;
						});
					} else {
						self.$message.error(r.msg);
					}
				})
				.catch((error) => {
					console.log(error);
					// 错误处理已在拦截器中统一处理
				});
		},
		// 获取机型及开发名
		getRepairDevice() {
			let self = this;
			self.$request.get("getRepairDevice", false, {}, function (r) {
				if (r.code == "0") {
					// 删除最后一级的children属性
					for (const element of r.data) {
						for (let index = 0; index < element.children.length; index++) {
							const extAttr = element.children[index];
							delete extAttr.children;
						}
					}
					self.repairDeviceOptions = r.data;
				} else {
					self.$message.error(r.msg);
				}
			});
		},
		// 获取省市县三级
		getDataAddr() {
			let self = this;
			self.$request.get("getDataAddr", false, {}, function (r) {
				if (r.code == "0") {
					self.addressOptions = r.data;
				} else {
					self.$message.error(r.msg);
				}
			});
		},
		// 上传前校验
		handleBeforeUpload(file) {
			if (this.isSuperAdmin) {
				// 超管单个文件大小限制1G
				const limitSize = file.size / 1024 / 1024 / 1024 <= 1;
				if (!limitSize) {
					this.$message.warning("文件大小不能超过1G");
					return false;
				}
			} else {
				// 非超管单个文件大小限制255M
				// 2022-07-31 应客户要求改为200M
				const limitSize = file.size / 1024 / 1024 <= 200;
				if (!limitSize) {
					this.$message.warning("文件大小不能超过200M");
					return false;
				}
			}
		},
		// 上传失败回调
		handleError(err, file, fileList) {
			console.log(`handleError`);
			console.log(err);
		},
		// 上传成功回调
		handleSuccess(type, response, file, fileList) {
			if (type === "purchase") {
				this.purchaseLeaseFileIdList.push(file.response.data); // 更新购机发票列表
			} else if (type === "smc") {
				this.smcFileIdList.push(file.response.data); // 更新 SMC 列表
			} else if (type === "failureSample") {
				this.failureSampleFileIdList.push(file.response.data); // 更新 故障样张或照片 列表
			} else if (type === "faultyParts") {
				this.faultyPartsFileIdList.push(file.response.data); // 更新 故障零件或耗材 列表
			} else if (type === "warranty") {
				this.cardInSystemFileIdList.push(file.response.data); // 更新 保修卡 列表
			}
		},
		// 删除上传文件
		handleAttachFileRemove(file, fileListName) {
			this[fileListName].splice(this[fileListName].indexOf(file), 1);
		},
		// 返回列表页
		handleBack() {
			this.$router.push({
				path: sessionStorage.getItem("claimRoute"),
			});
		},
		// 资料后补提交
		handleSupplement() {
			if (this.lastIntro == "") {
				this.$message.error("请填写资料后补说明");
				return;
			}
			if (this.isPrepaid && this.prepaidExpress == false) {
				this.$message.error("请补写寄件信息");
				return;
			}
			// 请确保后续提交的材料/物品都符合索赔标准
			const params = {
				id: this.form.id,
				partsClaimWarranty: {
					id: this.form.partsClaimWarranty.id,
					lastIntro: this.lastIntro,
					purchaseLeaseFileIdList: [],
					purchaseLeaseRemark: null,
					smcFileIdList: [],
					smcRemark: null,
					failureSampleFileIdList: [],
					failureSampleRemark: null,
					faultyPartsFileIdList: [],
				},
			};
			if (this.purchaseLeaseFileIdList.length > 0) {
				for (const element of this.purchaseLeaseFileIdList) {
					params.partsClaimWarranty.purchaseLeaseFileIdList.push(element.id);
				}
			}
			if (this.smcFileIdList.length > 0) {
				for (const element of this.smcFileIdList) {
					params.partsClaimWarranty.smcFileIdList.push(element.id);
				}
			}
			if (this.failureSampleFileIdList.length > 0) {
				for (const element of this.failureSampleFileIdList) {
					params.partsClaimWarranty.failureSampleFileIdList.push(element.id);
				}
			}
			if (this.faultyPartsFileIdList.length > 0) {
				for (const element of this.faultyPartsFileIdList) {
					params.partsClaimWarranty.faultyPartsFileIdList.push(element.id);
				}
			}
			this.$confirm(`请确保后续提交的材料/物品都符合索赔标准`, "", {
				confirmButtonText: "确定",
				cancelButtonText: "取消",
			})
				.then(() => {
					let self = this;
					self.$request.post("addClaimWarrantyMaterials", true, params, function (r) {
						if (r.code == "0") {
							self.$message.success("保存成功");
						} else {
							self.$message.error(r.msg);
						}
					});
				})
				.catch(() => {});
		},
		// 先行赔付补写寄件信息
		// 填写退件信息
		handleAddressInfo() {
			this.$refs.addressInfo.init({
				id: this.form.partsClaimWarranty.id,
				linkTable: "parts_claim_warranty",
				expressType: "4",
				applyAdvanceCode: this.form.partsClaimWarranty.applyAdvanceCode,
				innerAdvanceCode: this.form.partsClaimWarranty.innerAdvanceCode,
			});
		},
		// 查看索赔退件信息
		checkAddressInfo(partsClaimExpress) {
			this.$refs.showAddressInfo.init(partsClaimExpress);
		},
		updateExpress() {
			this.prepaidExpress = true;
		},
		// 索赔进度
		progressMsg(part) {
			let msg = "";
			if (part.partsResult == 1) {
				msg = "实物审批被拒";
			} else {
				if (part.currentAudit.auditStatus == 1) {
					msg = "实物审批已通过";
				} else if (part.currentAudit.auditStatus == 2) {
					msg = "无货等待";
				} else if (part.currentAudit.auditStatus == 3) {
					msg = "索赔成功";
				} else if (part.currentAudit.auditStatus == -2) {
					msg = "拒绝发货";
				} else {
					msg = "实物审批已通过";
				}
			}
			return msg;
		},
		// 下载pdf
		handleDownloadPdf() {
			// 默认模板
			const newForm = {
				...this.$data,
			};
			if (!newForm) {
				console.error("默认模板 data is undefined");
				return;
			}
			this.$refs.appendix1.init(newForm);
		},
	},
};
</script>

<style lang="scss" scoped>
.create-page {
	display: flex;
	flex-direction: column;
}
.create-tab {
	width: 160px;
	border-bottom: 2px solid #409eff;
	text-align: center;
	padding-bottom: 10px;
	margin-bottom: 20px;
}
.create-section {
	padding-bottom: 20px;
	border: 1px solid #ae8d5a;
	border-radius: 8px;
	h3 {
		height: 60px;
		line-height: 60px;
		padding: 0 20px;
		border-bottom: 1px solid #dcdfe6;
	}
}
.type-list {
	display: grid;
	grid-template-columns: 1fr 1fr 1fr; /* 定义列 */
	gap: 20px; /* 间距 */
	margin: 20px 20px 0;
	.claim-type {
		display: flex;
		align-items: center;
		justify-content: center;
		flex-direction: column;
		padding: 34px 20px;
		border-radius: 4px;
		border: 2px solid rgba(0, 0, 0, 0.15);
		font-size: 20px;
		font-weight: 500;
		color: #aaa7a7;
		cursor: pointer;
		.tip {
			margin-top: 10px;
			font-weight: 500;
			font-size: 12px;
			color: #666;
			word-break: break-all;
		}
	}
	.selected {
		border-color: #409eff;
		color: #409eff;
	}
}
.grid-box {
	display: grid;
	grid-template-columns: 1fr 1fr 1fr; /* 定义列 */
	gap: 20px; /* 间距 */
	margin: 0 20px;
	.el-cascader,
	.el-date-editor {
		width: 100%;
	}
}
.grid-box1 {
	grid-template-columns: 1fr 2fr; /* 定义列 */
}
/* 使用深度选择器 */
.el-form-item ::v-deep .el-form-item__label {
	padding: 0;
}
.hidden-label ::v-deep .el-form-item__label {
	opacity: 0;
}
.el-form-item1 ::v-deep .el-form-item__label {
	line-height: 20px;
}
.claim-user-box {
	margin: 0 20px;
	button {
		margin-left: 10px;
	}
}
.claim-user {
	color: rgba(0, 0, 0, 0.87);
	border: none;
	cursor: default;
	height: 34px;
	display: inline-flex;
	outline: 0;
	padding: 2px 10px;
	font-size: 0.8125rem;
	box-sizing: border-box;
	transition:
		background-color 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,
		box-shadow 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
	align-items: center;
	white-space: nowrap;
	border-radius: 16px;
	vertical-align: middle;
	justify-content: center;
	text-decoration: none;
	background-color: #e0e0e0;
	cursor: pointer;
	img {
		color: transparent;
		width: 100%;
		height: 100%;
		object-fit: cover;
		text-align: center;
		text-indent: 10000px;
	}
}
.radio-box {
	margin: 0 20px;
	p {
		color: rgba(0, 0, 0, 0.54);
		padding: 0;
		font-size: 1rem;
		font-weight: 400;
		line-height: 1;
		letter-spacing: 0.00938em;
		margin: 10px 0;
	}
}
.el-radio ::v-deep .el-radio__inner {
	width: 20px;
	height: 20px;
}
.el-radio ::v-deep .el-radio__label {
	font-size: 16px;
	color: #000;
}
.upload-box {
	margin: 10px 20px;
	h4,
	p {
		margin-bottom: 10px;
	}
	p {
		color: rgba(0, 0, 0, 0.54);
		padding: 0;
		font-size: 1rem;
		font-weight: 400;
		line-height: 1;
		letter-spacing: 0.00938em;
	}
}
.upload-box ::v-deep .el-upload-dragger {
	display: flex;
	flex-direction: column;
	justify-content: center;
	height: 120px;
	width: 120px;
	.el-icon-upload {
		font-size: 40px;
		line-height: unset;
		margin: unset;
	}
}
.create-footer {
	display: flex;
	div {
		flex: 1;
	}
	margin-top: 10px;
}
.fixed-btn-box {
	position: fixed;
	top: 80px;
	right: calc(10vw - 80px);
	button {
		display: block;
		margin-left: 0;
		margin-bottom: 10px;
	}
}
.flex {
	display: flex;
}
.flex-1 {
	flex: 1;
	padding: 10px;
}
.part-info-box {
	margin: 10px 20px;
	box-shadow:
		0px 2px 1px -1px rgba(0, 0, 0, 0.2),
		0px 1px 1px 0px rgba(0, 0, 0, 0.14),
		0px 1px 3px 0px rgba(0, 0, 0, 0.12);
	border-radius: 5px;
	.delete-btn-box {
		text-align: right;
		font-size: 20px;
		cursor: pointer;
		padding-right: 5px;
	}
	.flex-1 {
		position: relative;
		min-width: 0;
		word-wrap: break-word;
		.watermark {
			width: 100px;
			position: absolute;
			top: 0;
			right: 0;
		}
	}
}
.part-info-item {
	display: flex;
	align-items: flex-end;
	.el-form-item {
		flex: 1;
		margin-bottom: 5px;
	}
	.info-box {
		flex: 1;
		.title {
			margin-top: 10px;
		}
		.content {
			border: 1px solid #ddd;
			border-radius: 5px;
			padding: 9px 12px;
			margin-top: 5px;
			font-size: 13px;
		}
	}
	i {
		font-size: 28px;
		cursor: pointer;
		margin-bottom: 10px;
	}
}
.part-info-box-right {
	background-color: rgba(0, 0, 0, 0.02);
	font-size: 16px;
	.right-item {
		margin-bottom: 10px;
		.flex-1 {
			padding-top: 0;
		}
	}
}
.mt20 {
	margin-top: 20px;
}
.ml20 {
	margin-left: 20px;
}
.color-red {
	color: red;
}
.mr20 {
	margin: 0 20px;
}
.notice {
	color: #409eff;
	display: inline-block;
	text-decoration: underline;
	margin-left: 30px;
	cursor: pointer;
}
iframe {
	width: 100%;
	height: 70vh;
}
.iframe-dialog ::v-deep .el-dialog__header {
	display: none;
}
.iframe-dialog ::v-deep .el-dialog__body {
	padding: 0;
}
.subtitle {
	font-size: 1rem;
	font-weight: 400;
	line-height: 1.75;
	letter-spacing: 0.00938em;
	margin: 0 20px;
}
.border-bottom-none {
	border-bottom: none !important;
}
.pb0 {
	padding-bottom: 0;
}
.height45 {
	height: 45px !important;
}
.add-section {
	margin: 0 20px;
	.title1,
	.el-input,
	.el-button {
		margin-top: 10px;
	}
	.title2 {
		color: #909399;
		font-size: 12px;
	}
}
.number-span {
	float: right;
	font-size: 16px;
	font-weight: normal;
}
.word-bread-all {
	white-space: pre-line;
	word-break: break-all;
}
.log-section {
	.el-table {
		margin-left: 20px;
		width: calc(100% - 40px);
		margin-top: 20px;
		font-size: 12px;
	}
}
</style>
<style>
.create-tooltip {
	width: 220px;
}
</style>
